// import React, { useState } from 'react';
// import deleteIcon from '../assets/delete.svg';
// import SuccessModal from '../components/PasswordRequestModal';

// const UpdatePasswordModal = ({ isOpen, onClose, onBookAnotherRide }) => {
//   const [isModalOpen, setModalOpen] = useState(false);
//   if (!isOpen) return null;
//   const openModal = () => setModalOpen(true);
//   const closeModal = () => setModalOpen(false);

//   return (
//     <div
//       className='d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100'
//       style={{
//         backgroundColor: 'rgba(0, 0, 0, 0.4)',
//         zIndex: 1050,
//         backdropFilter: 'blur(5px)',
//       }}
//     >
//       <div
//         className='d-flex flex-column justify-content-center align-items-center bg-white shadow'
//         style={{
//           width: '90%',
//           maxWidth: '700px',
//           height: '500px',
//           borderRadius: '20px',
//           padding: '40px 40px',
//         }}
//       >
//         <div
//           className='d-flex justify-content-center align-items-center mx-auto mb-3'
//           style={{
//             width: '60px',
//             height: '60px',
//             borderRadius: '50%',
//           }}
//         >
//           <img src={deleteIcon} alt='delete icon' />
//         </div>
//         <h3 className='fw-bold text-center mb-5 mt-3'>
//           Send request to update password?
//         </h3>
//         <div
//           className='d-flex flex-wrap justify-content-center gap-3'
//           style={{ width: '100%' }}
//         >
//           <button
//             className='btn text-white px-4'
//             style={{
//               backgroundColor: '#ff7a00',
//               padding: '5px 20px',
//               borderRadius: '8px',
//               fontWeight: '600',
//               cursor: 'pointer',
//             }}
//             onClick={openModal}
//           >
//             Yes, I am sure
//           </button>
//           <SuccessModal isOpen={isModalOpen} onClose={closeModal} />
//           <button
//             className='btn px-4'
//             style={{
//               backgroundColor: '#fff',
//               color: '#1f1f21',
//               border: '1px solid #969696',
//               padding: '5px 20px',
//               borderRadius: '8px',
//               fontWeight: '600',
//               cursor: 'pointer',
//             }}
//             onClick={onClose}
//           >
//             Back to Dashboard
//           </button>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default UpdatePasswordModal;

import React, { useState } from 'react';
import deleteIcon from '../assets/delete.svg';
import SuccessModal from '../components/PasswordRequestModal';

const UpdatePasswordModal = ({ isOpen, onClose }) => {
  const [isSuccessModalOpen, setSuccessModalOpen] = useState(false);

  if (!isOpen) return null;

  const openSuccessModal = () => {
    setSuccessModalOpen(true);
  };

  const closeSuccessModal = () => {
    setSuccessModalOpen(false);
    onClose(); // Ensure both modals are closed
  };

  return (
    <div
      className='d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100'
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.4)',
        zIndex: 1050,
        backdropFilter: 'blur(5px)',
      }}
    >
      <div
        className='d-flex flex-column justify-content-center align-items-center bg-white shadow'
        style={{
          width: '90%',
          maxWidth: '700px',
          height: '500px',
          borderRadius: '20px',
          padding: '40px 40px',
        }}
      >
        <div
          className='d-flex justify-content-center align-items-center mx-auto mb-3'
          style={{
            width: '60px',
            height: '60px',
            borderRadius: '50%',
          }}
        >
          <img src={deleteIcon} alt='delete icon' />
        </div>
        <h3 className='fw-bold text-center mb-5 mt-3'>
          Send request to update password?
        </h3>
        <div
          className='d-flex flex-wrap justify-content-center gap-3'
          style={{ width: '100%' }}
        >
          <button
            className='btn text-white px-4'
            style={{
              backgroundColor: '#ff7a00',
              padding: '5px 20px',
              borderRadius: '8px',
              fontWeight: '600',
              cursor: 'pointer',
            }}
            onClick={openSuccessModal}
          >
            Yes, I am sure
          </button>
          {/* Pass the close logic to SuccessModal */}
          <SuccessModal
            isOpen={isSuccessModalOpen}
            onClose={closeSuccessModal}
          />
          <button
            className='btn px-4'
            style={{
              backgroundColor: '#fff',
              color: '#1f1f21',
              border: '1px solid #969696',
              padding: '5px 20px',
              borderRadius: '8px',
              fontWeight: '600',
              cursor: 'pointer',
            }}
            onClick={onClose}
          >
            Back to Dashboard
          </button>
        </div>
      </div>
    </div>
  );
};

export default UpdatePasswordModal;
